import { Drawer, List, ListItem } from "@material-ui/core";
import React, { useState } from "react";
import { IoIosMenu } from "react-icons/io";
import { IconButton } from "@chakra-ui/react";
import { NavHashLink } from "react-router-hash-link";
import "./NavBar.css";

const NavBar = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  return (
    <div className="navbar">
      <IconButton
        colorScheme="primary"
        fontSize="3rem"
        onClick={() => setOpenDrawer(!openDrawer)}
        aria-label="menu"
        icon={<IoIosMenu />}
        className="menuButton"
      />
      <Drawer
        anchor="right"
        PaperProps={{
          style: {
            minWidth: "280px",
            width: "20%",
            background: "#BFDBF7",
            color: "#053C5E",
            padding: "2rem",
          },
        }}
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <List className="menuList" spacing={3}>
          <ListItem className="listItem" onClick={() => setOpenDrawer(false)}>
            <NavHashLink to="/" smooth={true}>
              Home
            </NavHashLink>
          </ListItem>
          <ListItem className="listItem" onClick={() => setOpenDrawer(false)}>
            <NavHashLink smooth to="#about">
              About me
            </NavHashLink>
          </ListItem>
          <ListItem className="listItem" onClick={() => setOpenDrawer(false)}>
            <NavHashLink smooth to="/#skills">
              Skills
            </NavHashLink>
          </ListItem>
          <ListItem className="listItem" onClick={() => setOpenDrawer(false)}>
            <NavHashLink smooth to="/#projects">
              Projects
            </NavHashLink>
          </ListItem>
          <ListItem className="listItem" onClick={() => setOpenDrawer(false)}>
            <NavHashLink smooth to="/#experience">
              Experience
            </NavHashLink>
          </ListItem>
          <ListItem className="listItem" onClick={() => setOpenDrawer(false)}>
            <NavHashLink smooth to="/#contact">
              Contact
            </NavHashLink>
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
};

export default NavBar;
